<template>
	<div id="app" :style="global_style">
		<PlayerName></PlayerName>
		<router-view/>
	</div>
</template>

<style>
html, body {
	height: 100%;
	margin: 0;
}

* {
	user-select: none;
}

#app {
	background-color: var(--bg_color);
}
input {
	border-radius: 2px;
	border: 1px solid var(--border_color);
	background-color: var(--ui_color);
}
button {
	border-radius: 5px;
	border: 1px solid var(--border_color);
	background-color: var(--ui_color);
}
button:active {
	background-color: var(--ui_active_color);
}
button:disabled {
	background-color: var(--ui_active_color);
}
button:focus {
	outline: none;
}
p, button, input {
	color: var(--text_color);
}

.fg_background {
	fill: var(--fg_bg_color);
}
.fg_background_stroke {
	stroke: var(--fg_bg_stroke_color);
}
.fg_stroke {
	stroke: var(--fg_stroke_color);
}

#app {
	font-family: sans-serif;
	color: #2C3E50;
	min-height: 100%;
	display: flex;
	flex-direction: column;
}
</style>

<script lang="ts">
import Vue from 'vue'

import PlayerName from './components/PlayerName.vue'

export default Vue.extend({
	name: "Uno",
	metaInfo: {
		title: "Uno"
	},
	components: {
		PlayerName
	},
	computed: {
		global_style() {
			if (this.$store.state.dark) {
				return {
					"--shadow_color": "#AAAAAA",
					"--border_color": "#ADADAD",
					"--bg_color": "#121212",
					"--ui_color": "#222222",
					"--ui_active_color": "#323232",
					"--text_color": "#EEEEEE",
					"--fg_bg_color": "#222222",
					"--fg_bg_stroke_color": "#666666",
					"--fg_stroke_color": "#222222"
				};
			} else {
				return {
					"--shadow_color": "#000000",
					"--border_color": "#121212",
					"--bg_color": "#EEEEEE",
					"--ui_color": "#F7F7F7",
					"--ui_active_color": "#DDDDDD",
					"--text_color": "#121212",
					"--fg_bg_color": "#FFFFFF",
					"--fg_bg_stroke_color": "#000000",
					"--fg_stroke_color": "#FFFFFF"
				};
			}
		}
	},
	methods: {
		on_message(event) {
			var obj = JSON.parse(event["data"]);
			console.log(obj);

			if (obj[0] == "game_data") {
				var data = obj[1];
				switch (data.type) {
				case "NotInRoom":
					this.$router.push("/notinroom").catch(() => {});
					break;
				case "Waiting":
					this.$router.push("/waiting").catch(() => {});
					break;
				case "Playing":
					this.$router.push("/playing").catch(() => {});
					break;
				}
				this.$store.commit("set_data", data);
			}
		}
	},
	created() {
		// this is mostly for hot reloading, on the actual client this won't happen i think?
		if (this.$store.state.connection != null) {
			this.$store.state.connection.close();
		}

		console.log("Starting websocket connection");
		var connection = new WebSocket(process.env.VUE_APP_WEBSOCKET_URL);

		connection.addEventListener("message", this.on_message);

		connection.onopen = (event) => {
			console.log(event);
			console.log("Successfully connected to the websocket server");
		};

		connection.onclose = (event) => {
			console.log(event);
			alert("Websocket connection closed. This is probably a server bug. Please restart.");
		};

		this.$store.commit("set_connection", connection);

		this.$store.commit("set_player_name", "Player");

		if (window.matchMedia != undefined) {
			var x = window.matchMedia("(prefers-color-scheme: dark)");
			this.$store.commit("set_dark", x.matches);
			x.addListener((m) => { this.$store.commit("set_dark", m.matches); });

			var y = window.matchMedia("(max-width: 500px), (max-height: 500px)");
			this.$store.commit("set_mobile", y.matches);
			y.addListener((m) => { this.$store.commit("set_mobile", m.matches); });
		}
	}
})
</script>
